export default __webpack_public_path__ + "static/media/ecoppercrossbow.869cd436.PNG";